export enum InvoicePaymentTerms {
  NET_30 = "NET_30",
  NET_60 = "NET_60",
  NET_90 = "NET_90",
  IMMEDIATELY = "IMMEDIATELY",
}
